module.exports = __webpack_public_path__ + "img/LiftSmart-Demo copy.9145e255.gif";